import { CHECKOUT_URL } from './constants'

export function scrollToOffer(): void {
  const el = document.getElementById('oferta')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

export function goToCheckout(): void {
  window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer')
}
